import { Dropdown } from 'primeng/dropdown';
import { isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { ForwarderCooperationResponse } from './interface/forwarder-cooperation-response';
import { ForwarderCooperationRequest } from './interface/forwarder-cooperation-request';
import { CodeConverterOptions } from './../../../../core/models/options/code-converter-options';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { DateTableColumn } from 'src/app/core/models/date-table-column';
import { LaasOption } from 'src/app/core/models/laas-option';
import { PageInfo } from 'src/app/core/models/page-info';
import { copyFormControl } from 'src/app/core/utils/validation-functions';
import { ForwarderCooperationService } from '../../services/forwarder-cooperation.service';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { DataTableComponent } from 'src/app/shared/components/data-table/data-table.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';

@Component({
  selector: 'laas-forwarder-cooperation',
  templateUrl: './forwarder-cooperation.component.html',
  styleUrls: ['./forwarder-cooperation.component.scss']
})
export class ForwarderCooperationComponent extends SessionBaseComponent implements OnInit {
  isSearchFormOpen: boolean;
  isHeaderLoading: boolean;
  headerChecked: boolean;
  searchValueIsValid: boolean;
  searchAllMode: boolean;
  firstTimeSearch: boolean;

  searchForm: FormGroup;
  pageInfo: PageInfo;
  sortInfo?: [{ property: string; direction: number }];
  first: number;

  allCityOptions: LaasOption[];
  countryOptions: LaasOption[];
  toCityOptions: LaasOption[];
  fromCityOptions: LaasOption[];
  shippingTypeOptions: LaasOption[];
  shiptermOptions: LaasOption[];
  forwarderOptions: LaasOption[];

  facilityOptions: LaasOption[];
  rfqCategoryTypeOptions: LaasOption[];

  tableValue: ForwarderCooperationResponse[];
  tableColumns: DateTableColumn[];
  selectedTableColumns: DateTableColumn[];
  selectedRow: ForwarderCooperationResponse;
  selectedRowsWithCheckBox: ForwarderCooperationResponse[];

  readonly viewPermissionCode = PermissionConstants.ViewForwarderCooperation;
  readonly headerPreferenceKey: string = UserPreferenceConstants.ForwarderCooperationResponse;

  currentLang: string = this.laasSetting.language;
  isShowDescriptionModel: boolean;

  constructor(injector: Injector, private formBuilder: FormBuilder, private dropdownOptionsService: DropdownOptionsService,
      private facilityService: FacilityService, private commonDataService: CommonDataService, private forwarderCooperationService: ForwarderCooperationService) {
    super(injector);

    this.isSearchFormOpen = true;
    this.isHeaderLoading = false;
    this.headerChecked = false;
    this.searchValueIsValid = false;
    this.searchAllMode = false;
    this.firstTimeSearch = false;

    this.searchForm = this.formBuilder.group({
      fromLocation: null,
      toLocation: null,
      shippingType: null,
      shipTerm: null
    });

    this.first = 0;
    this.pageInfo = {
      pageIndex: 0,
      totalPages: 0,
      totalRecords: 0,
      pageSize: 5
    }
    this.sortInfo = undefined;

    this.countryOptions = [];
    this.allCityOptions = [];
    this.toCityOptions = [];
    this.fromCityOptions = [];
    this.shippingTypeOptions = [];
    this.shiptermOptions = [];
    this.forwarderOptions = [];

    this.facilityOptions = [];
    this.rfqCategoryTypeOptions = [];

    this.tableValue = [];
    this.tableColumns = this.headerTableTranslation();

    this.selectedTableColumns = [];
    this.selectedRow = {};
    this.selectedRowsWithCheckBox = [];

    this.isShowDescriptionModel = false;

  }

  @ViewChild("DataTableComponent") table!: DataTableComponent;

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
    // permission Codes
    this.permissionCodes = (
      Object.values(this.userProfile.roles).reduce(
        (c: any, i: any) => c.concat(i.permissions),
        []
      ) as any
    ).map((x: any) => {
      return x.permissionCode;
    });
    console.log(this.permissionCodes)
    //rbac to maintain this page
    var canInPage = this.permissionCodes.includes(this.viewPermissionCode);
    if (!canInPage) {
      //go unAuthorize
      this.routeStateService.navigateTo('/Error/unAuthorize');
    }

    this.dropdownOptionsService.findFacilityOptionsByOptionType('ShippingType').subscribe({
      next: (result) => {
        this.shippingTypeOptions = [...result].map((x: FacilityOptions) => {
          return {
            label: x.optionDesc,
            value: x.optionCode
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'WarehousingShipTerm').subscribe({
      next: (result) => {
        this.shiptermOptions = [...result].map((x: CodeConverterOptions) => {
          return {
            label: `${x.codeKey} - ${x.codeDesc}`,
            value: x.codeKey
          };
        });
      }
    });

    this.forwarderCooperationService.getForwarderList().subscribe({
      next: (result) => {
        this.forwarderOptions = [...result].map((x: any) => {
          return {
            label: `${x.text}`,
            value: x.value
          };
        });
      }
    });

    this.dropdownOptionsService.getFacilityOptions()
      .subscribe({
        next: (options) => {
          this.facilityOptions = [...options].map((x: FacilityOptions) => {
            return {
              label: `${x.optionDesc}`,
              value: x.optionCode
            };
          });
        }
      });

      this.dropdownOptionsService.getRfqCategoryTypeOptions()
      .subscribe({
        next: (options) => {
          this.rfqCategoryTypeOptions = [...options].map((x: FacilityOptions) => {
            return {
              label: `${x.optionDesc}`,
              value: x.optionCode
            };
          });
        }
      });
  }

  // ===== Options Ready 事件處理 =====
  onCountryOptionsReady(options: any[]): void {
    this.countryOptions = options.map((x) => ({
      label: x.countryName || x.label,
      value: x.countryCode || x.value,
    }));
    this.countryOptions.unshift({ label: 'ALL', value: 'ALL' });
  }

  onCityOptionsReady(options: any[]): void {
    this.allCityOptions = options.map((x) => ({
      label: x.cityName || x.name || x.label,
      value: x.cityCode || x.seqNo?.toString() || x.value,
    }));
    this.allCityOptions.unshift({ label: 'ALL', value: 'ALL' });
  }

  searchBtnClick() {
    this.table.setCurrentPage(0);
    this.pageInfo.pageIndex = 0;
    this.doSearch()
  }

  doSearch() {
    // 轉換巢狀的 location 資料為原本的扁平格式
    const searchRequest = this.convertLocationDataForSearch();

    this.firstTimeSearch = true;
    console.log(searchRequest);
    if (this.checkSearchValueInValid(searchRequest)) {
      this.isHeaderLoading = true;
      console.log(searchRequest);
      this.forwarderCooperationService.searchForwarderCoopearation(searchRequest).subscribe({
        next: (result) => {
          console.log(result);
          if (result.content) {
            result.content.forEach((col: any, index: number) => col.index = index);
          }
          this.tableValue = result.content;
          this.pageInfo.pageIndex = result.pageable.pageNumber;
          this.pageInfo.totalRecords = result.totalElements;
          this.isHeaderLoading = false;
          this.isSearchFormOpen = false;
        }
      });
    }
  }

  // ===== 轉換 location 資料為搜尋格式 =====
  private convertLocationDataForSearch(): ForwarderCooperationRequest {
    const formValue = this.searchForm.value;

    // 建立新的 ForwarderCooperationRequest 物件
    const request = new ForwarderCooperationRequest();

    // 轉換起運地
    request.fromCountry = formValue.fromLocation?.country || null;
    request.fromCity = formValue.fromLocation?.city || null;

    // 轉換目的地
    request.toCountry = formValue.toLocation?.country || null;
    request.toCity = formValue.toLocation?.city || null;

    // 其他欄位
    request.shippingType = formValue.shippingType || null;
    request.shipTerm = formValue.shipTerm || null;

    // 設定分頁資訊（從元件的 pageInfo 取得）
    request.pageIndex = this.pageInfo.pageIndex;
    request.pageSize = this.pageInfo.pageSize;
    request.sortInfo = this.sortInfo;
    request.searchAllMode = this.searchAllMode;

    console.log('轉換後的 ForwarderCooperationRequest:', request);
    return request;
  }

  resetBtnClick() {
    this.searchForm.reset();
  }

  tablePageChange(event: any): void {
    this.pageInfo.pageSize = event.rows;
    this.pageInfo.pageIndex = event.first / this.pageInfo.pageSize;
    this.doSearch();
  }

  tableSort(event: any): void {
    this.sortInfo = [{ property: event.field, direction: event.order }];
    this.doSearch();
  }

  goToFreightTrialCalculation() {
    let searchRequest = new ForwarderCooperationRequest();
    searchRequest = copyFormControl(this.searchForm, searchRequest);
    this.forwarderCooperationService.setMessage(searchRequest);
    this.routeStateService.navigateTo('/TransportOperation/FreightTrialCalculation', { serchParams: searchRequest });
  }

    // translate table
    headerTableTranslation(): DateTableColumn[] {
      var fields: string[];
      var jsons: string[];
      var tmpcolumn: DateTableColumn[] = [];

      fields = ['fromCountry', 'fromCity', 'toCountry', 'toCity', 'forwarder', 'incoTerm', 'remark', 'shippingType', 'facility', 'rfqCategory'];

      jsons = ['ForwarderCooperation.TableColumn.FromCountry', 'ForwarderCooperation.TableColumn.FromCity', 'ForwarderCooperation.TableColumn.ToCountry',
      'ForwarderCooperation.TableColumn.ToCity', 'ForwarderCooperation.TableColumn.Forwarder', 'ForwarderCooperation.TableColumn.IncoTerm',
      'ForwarderCooperation.TableColumn.Remark', 'ForwarderCooperation.TableColumn.ShippingType', 'ForwarderCooperation.TableColumn.Facility',
      'ForwarderCooperation.TableColumn.RFQCategory' ];

      for (let i = 0; i < fields.length; i++) {
        tmpcolumn[i] = { field: fields[i], header: jsons[i], sort: true};
      }
      return tmpcolumn;
    }

    checkSearchValueInValid(searchFormValue: ForwarderCooperationRequest): boolean {
      if (isNullOrEmpty(searchFormValue.toCountry) ||
          isNullOrEmpty(searchFormValue.fromCountry) ||
          isNullOrEmpty(searchFormValue.fromCity) ||
          isNullOrEmpty(searchFormValue.toCity)) {
        this.toastService.warn(this.translateService.instant("ForwarderCooperation.SearchValueInvalid.InvalidSearchValueFromCountryToCountry"));
        this.searchValueIsValid = true;
        return false;
      }

      this.searchValueIsValid = false; // 重置驗證狀態
      return true;
    }

    showValidationMessage(control: any): boolean {
      return isNullOrEmpty(control);
    }

    changeSearchMode(event: any) {
      this.searchAllMode = event.checked;
    }

    showForwarderDesc(val: boolean) {
      this.isShowDescriptionModel = val;
    }

    importdailyRate(event: any): void {
      this.isShowDescriptionModel = false;
    }

    dialogVisibleChange(val: boolean) {
      this.isShowDescriptionModel = val;
    }
}
